<section class="zona-fan2">
    <div class="container">
        <h1 class="section-tit1">{{zf_tit}}</h1>
        <div class="areas">
            <h2 class="section-tit1 isotipo-triple">
                <neo-span-inner-html [contenido]="complejo_tit"></neo-span-inner-html>
            </h2>
            <article class="suelo">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub9}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt9"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img9['ruta']" [alt]="complejo_img9['alt']" />
                    </picture>
                </div>
            </article>
            <article class="piscina">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub1}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt1"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img1['ruta']" [alt]="complejo_img1['alt']" />
                    </picture>
                </div>
            </article>
            <article class="tirolina">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub2}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt2"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img2['ruta']" [alt]="complejo_img2['alt']" />
                    </picture>
                </div>
            </article>
            <article class="paintball">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub3}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt3"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img3['ruta']" [alt]="complejo_img3['alt']" />
                    </picture>
                </div>
            </article>
            <article class="deporte">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub4}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt4"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img4['ruta']" [alt]="complejo_img4['alt']" />
                    </picture>
                </div>
            </article>
            <article class="hoverboard">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub5}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt5"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img5['ruta']" [alt]="complejo_img5['alt']" />
                    </picture>
                </div>
            </article>
            <article class="zona-cubierta">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub6}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt6"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img6['ruta']" [alt]="complejo_img6['alt']" />
                    </picture>
                </div>
            </article>
            <article class="terraza">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub7}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt7"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img7['ruta']" [alt]="complejo_img7['alt']" />
                    </picture>
                </div>
            </article>
            <article class="aire-libre">
                <div class="blq-cont">
                    <div>
                        <h3 class="section-tit2 isotipo-stroke">{{complejo_sub8}}</h3>
                        <neo-span-inner-html [contenido]="complejo_txt8"></neo-span-inner-html>
                    </div>
                </div>
                <div class="blq-img">
                    <picture>
                        <img [src]="complejo_img8['ruta']" [alt]="complejo_img8['alt']" />
                    </picture>
                </div>
            </article>
        </div>
    </div>

    <neo-mapa-areas></neo-mapa-areas>
<div class="container">
    <article class="historia">
        <div class="blq-cont">
            <div>
                <h2 class="section-tit2 isotipo-stroke">{{historia_sub}}</h2>
                <h3>{{historia_sub1}}</h3>
                <neo-span-inner-html [contenido]="historia_txt1"></neo-span-inner-html>
                <h3>{{historia_sub2}}</h3>
                <neo-span-inner-html [contenido]="historia_txt2"></neo-span-inner-html>
                <h3>{{historia_sub3}}</h3>
                <neo-span-inner-html [contenido]="historia_txt3"></neo-span-inner-html>
                <h3>{{historia_sub4}}</h3>
                <neo-span-inner-html [contenido]="historia_txt4"></neo-span-inner-html>
                <div class="blq-pie">
                    <neo-span-inner-html [contenido]="historia_pie"></neo-span-inner-html>
                </div>
            </div>
        </div>
        <div class="blq-img">
            <picture *ngFor="let imagen of historia_img">
                <img [src]="imagen['ruta']" alt="" [alt]="imagen['alt']"/>
            </picture>
        </div>
    </article>
</div>
</section>

<neo-bottom-cta></neo-bottom-cta>